import { Route } from 'vue-router';
import UserStoreModule from '../../user/store/module';
import redirectToHermes from '../../common/helpers/redirect-to-hermes';

/**
 * Route guard that immediately redirects to Hermes billing page
 * This prevents the component from rendering
 */
export async function redirectToHermesBillingGuard(
  to: Route,
  from: Route,
  next: Function,
): Promise<void> {
  const user = UserStoreModule.data;
  const storeId = user?.store?.id;

  if (storeId) {
    // Redirect immediately - this will prevent the component from loading
    await redirectToHermes({
      storeId: storeId,
      billing: true, // Redirect to finance/billing (not packages)
    });
    // Don't call next() - the redirect will happen via window.location.href
    return;
  }

  // If no store ID, allow normal navigation (fallback)
  next();
}
